/* eslint-disable */
import { bus } from '../../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
export default {
  name: 'contest-quiz-section-update',
  components: {
    draggable
  },
  props: [],
  data () {
    return {
      name:'',
      allocated_time:'',
      number_of_questions:'',
      index:'',
      submitted:false,
      quizSectionDetailsById:{},
      sectionConfigList:{},
      sectionConfigListResults:[],
      removeSectionConfigOfQuizPopupStatus:false,
      removeSectionConfigOfQuizId:'',
      updateSectionConfigOfQuizPopupStatus:false,
      updateSectionConfigId:'',
      difficulty_level:'',
      is_active:false,
    }
  },
  computed: {
    ...mapGetters([
      'getSectionDetailsByIdForQuizGetters',
      'getSectionConfigForQuizGetters'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    getQuizSectionDetailsByIdFun() {
      this.quizSectionDetailsById = this.$store.getters.getSectionDetailsByIdForQuizGetters.data
      return
    },
    setIntialStatesOfQuizSectionDetails(){
      if(this.quizSectionDetailsById != undefined){
        this.name = this.quizSectionDetailsById.name
        this.allocated_time = this.quizSectionDetailsById.allocated_time
        this.number_of_questions = this.quizSectionDetailsById.number_of_questions
        this.index = this.quizSectionDetailsById.index
        this.is_active = this.quizSectionDetailsById.is_active
      }
      return
    },
    getSectionConfigList(){
        this.sectionConfigList = this.$store.getters.getSectionConfigForQuizGetters.data
        return
    },
    setIntialStateOfSectionConfig(){
      if(this.sectionConfigList != undefined){
          this.sectionConfigListResults = this.sectionConfigList.results
      }
      return
    }
  },
  mounted () {
    this.getQuizSectionDetailsByIdFun
    this.setIntialStatesOfQuizSectionDetails
    this.getSectionConfigList
    this.setIntialStateOfSectionConfig
  },
  methods: {
    sectionIsActiveStatusFun(){
      if(this.is_active == true){
        this.is_active = false
      }else{
        this.is_active = true
      }
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz:this.$route.params.quizId,
            name: this.name,
            allocated_time: this.allocated_time,
            number_of_questions: this.number_of_questions,
            index:this.index,
            is_active:this.is_active
          }
          this.$store.dispatch('updateSectionDetailsByIdForQuizFun', {data:{ id: this.$route.params.quiz_sectionId, data: data}})
          .then((res) => {
            toast.success(res.data.msg);
            this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    getSectionCofigOfQuizAgain() {
      this.$store.dispatch('getSectionConfigForQuizFun', {
        id: this.$route.params.quiz_sectionId
      }).then((response) => {
        this.sectionConfigList = response.data.data
      })
    },
    updatedSectionSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz:this.$route.params.quizId,
            name: this.name,
            allocated_time: this.allocated_time,
            number_of_questions: this.number_of_questions,
            index:this.index,
            is_active:this.is_active
          }
          this.$store.dispatch('updateSectionDetailsByIdForQuizFun', {data:{ id: this.$route.params.quiz_sectionId, data: data}})
          .then((res) => {
            toast.success(res.data.msg);
            this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    removeSectionConfigOfQuizModalOpenFun(id){
      this.removeSectionConfigOfQuizPopupStatus = true
      this.removeSectionConfigOfQuizId = id
    },
    closeRemoveSectionConfigOfQuizModal(){
      this.removeSectionConfigOfQuizPopupStatus = false
      this.removeSectionConfigOfQuizId = ''
    },
    removeSectionConfigOfQuizModalOpenFunConfirmation(){
      this.$store.dispatch('removeSectionConfigForQuizByIdFun', {id: this.removeSectionConfigOfQuizId}).then((res) => {
        this.getSectionCofigOfQuizAgain()
        toast.success(res.data.msg);
        this.closeRemoveSectionConfigOfQuizModal()
      }).catch((err) => {})
      return

    },
    updatedSectionConfigOfQuizModalOpenFun(id, lavel){
      this.updateSectionConfigOfQuizPopupStatus = true
      this.updateSectionConfigId = id
      console.log(lavel, "Check")
      this.difficulty_level = lavel
    },
    updateSectionConfigSubmit(){
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz_section:this.$route.params.quiz_sectionId,
            difficulty_level: this.difficulty_level,
          }
          this.$store.dispatch('updateSectionConfigForQuizByIdFun', {data:{id:this.updateSectionConfigId,data:data}})
          .then((res) => {
            toast.success(res.data.msg);
            this.getSectionCofigOfQuizAgain()
            this.closeupdateSectionConfigOfQuizModal()
            this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    closeupdateSectionConfigOfQuizModal(){
      this.updateSectionConfigId = '',
      this.updateSectionConfigOfQuizPopupStatus = false
      this.difficulty_level = ''
    },
    bulletSortSectionConfigOfQuiz: function(event) {
      if (event.moved && event.moved != undefined) {
        this.updateSectionConfigOfQuizIndex(event.moved.element.id, Number(event.moved.newIndex) + 1);
      }
    },
    updateSectionConfigOfQuizIndex(tabId, rowIndex) {
      let data = {
        index: rowIndex
      }
      this.$store.dispatch('updateSectionConfigForQuizByIdFun', {
          data: {
            data: data,
            id: tabId
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getSectionCofigOfQuizAgain();
        })
        .catch((err) => {})
    },
  },
  watch:{
    getQuizSectionDetailsByIdFun() {
      this.quizSectionDetailsById = this.$store.getters.getSectionDetailsByIdForQuizGetters.data
      return
    },
    setIntialStatesOfQuizSectionDetails(){
      if(this.quizSectionDetailsById != undefined){
        this.name = this.quizSectionDetailsById.name
        this.allocated_time = this.quizSectionDetailsById.allocated_time
        this.number_of_questions = this.quizSectionDetailsById.number_of_questions
        this.index = this.quizSectionDetailsById.index
        this.is_active = this.quizSectionDetailsById.is_active
      }
      return
    },
    getSectionConfigList(){
        this.sectionConfigList = this.$store.getters.getSectionConfigForQuizGetters.data
        return
    },
    setIntialStateOfSectionConfig(){
      if(this.sectionConfigList != undefined){
          this.sectionConfigListResults = this.sectionConfigList.results
      }
      return
    }
  }
}